import { ColorModesScale } from 'theme-ui'

export const colors: ColorModesScale = {
  text: '#1a1a1a',
  background: 'white',
  primary: '#639',
  secondary: '#ff6347',
  inverted: 'white',
  neutral: {
    100: '#e5e5e5',
  },
}
